//import Swiper from 'swiper';
import Swiper from '../autoload/_swiper';

export default {
  init() {

      console.log("classes swiper");

      var swiperClass = ".classes-swiper";
      var classesSwiper = new Swiper(swiperClass, {

          //speed: 1200,
          //autoplay: {
          // delay: 2500,
          //disableOnInteraction: false,
          // },
          navigation: {
              nextEl: '.next',
              prevEl: '.prev',
          },

         // pagination: {
          //    el: '.swiper-pagination',
         //     clickable: true,

          //},
          slidesPerView: 1,
          spaceBetween: 30,
         // allowSlidePrev: false,
          //allowSlideNext: false,

          //noSwiping: true,
          //centeredSlides: true,
          //paginationClickable: true,
          noSwiping: true,
          //spaceBetween: 30,
          breakpoints: {
              1600: {
                  // slidesPerView: 2,
                  // spaceBetween: 30,
                  noSwiping: false,
                  //allowSlidePrev: true,
                  // allowSlideNext: true,
              },
              1200: {
                 // slidesPerView: 2,
                 // spaceBetween: 30,
                  noSwiping: false,
                  //allowSlidePrev: true,
                 // allowSlideNext: true,
              },
              992: {
                 // slidesPerView: 1.5,
                 // spaceBetween: 30,
                  noSwiping: false,
                 // allowSlidePrev: true,
                 // allowSlideNext: true,
              },
              768: {
                 // slidesPerView: 1.5,
                 // spaceBetween: 30,
                  noSwiping: false,
                 // allowSlidePrev: true,
                 // allowSlideNext: true,
              },
              576: {
                 // slidesPerView: 1.5,
                 // spaceBetween: 30,
                  noSwiping: false,
                 // allowSlidePrev: true,
                 // allowSlideNext: true,
              },
              320: {
                 // slidesPerView: 1,
                 // spaceBetween: 30,
                  noSwiping: false,
                 // allowSlidePrev: true,
                 // allowSlideNext: true,
              },
          },


      });

      classesSwiper.on('transitionStart', function () {

          console.log('transitionStart');

      });

      function updateSize(){

          var evt = window.document.createEvent('UIEvents');
          evt.initUIEvent('resize', true, false, window, 0);
          window.dispatchEvent(evt);
      }

      setTimeout( updateSize, 200);

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archiveClasses.js